import axios from 'axios';
import { toast } from 'sonner';

// Déclenche l'enregistrement d'un Blob par le navigateur (lien attaché au DOM, URL révoquée après démarrage du téléchargement)
export const saveBlob = (blob, filename) => {
  const b = blob instanceof Blob ? blob : new Blob([blob]);
  const href = URL.createObjectURL(b);
  const a = document.createElement('a');
  a.href = href;
  a.download = filename || 'document';
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(href); }, 60000);
};

// Télécharge un fichier protégé (JWT via interceptor axios) et déclenche l'enregistrement navigateur
export const downloadFile = async (url, filename, params, label = 'Fichier') => {
  try {
    const res = await axios.get(url, { responseType: 'blob', params });
    const cd = res.headers['content-disposition'] || '';
    const utf8 = cd.match(/filename\*=UTF-8''([^;]+)/);
    const match = cd.match(/filename="?([^";]+)"?/);
    const serverName = utf8 ? decodeURIComponent(utf8[1]) : match ? match[1] : null;
    saveBlob(res.data, filename || serverName || 'document');
    toast.success(`${label} téléchargé — vérifiez le dossier Téléchargements`);
    return true;
  } catch (e) {
    let detail = e.response?.data?.detail;
    if (e.response?.data instanceof Blob) {
      try { detail = JSON.parse(await e.response.data.text())?.detail; } catch { /* ignore */ }
    }
    toast.error(detail || `Erreur lors de la génération du ${label.toLowerCase()}`);
    return false;
  }
};

export const downloadPdf = (url, filename, params) => downloadFile(url, filename, params, 'PDF');
